import { useContext } from "react"
import { Helmet, HelmetProvider } from "react-helmet-async"
import MainContext from "../common/MainContext"
import { AdminRole } from "../common/constants"
import HeaderFooterLayout from "../components/layouts/HeaderFooterLayout"
import TagsSettings from "../components/settings/TagsSettings"
import CalendlyOrganizationSettings from "../components/settings/CalendlyOrganizationSettings"
import styles from "./Settings.module.css"

const Settings = () => {
    const context = useContext(MainContext)
    const canConfigureOrganization = context.user?.role === AdminRole.Main

    return (
        <HeaderFooterLayout>
            <HelmetProvider>
                <Helmet>
                    <title>Impostazioni</title>
                </Helmet>
            </HelmetProvider>
            <div className={styles.container}>
                <div className={styles.section}>
                    <div className={styles.sectionInner}>
                        <header className={styles.heading}><h1>Impostazioni</h1><p>Gestisci configurazioni e integrazioni condivise della piattaforma.</p></header>
                        {canConfigureOrganization && <div className={styles.group}>
                            <div className={styles.groupHeading}>
                                <h2>App e integrazioni</h2>
                                <p>Configurazioni valide per tutta l’organizzazione.</p>
                            </div>
                            <CalendlyOrganizationSettings />
                        </div>}
                        <div className={styles.group}>
                            <div className={styles.groupHeading}>
                                <h2>Tag</h2>
                                <p>Gestisci i tag utilizzati nella piattaforma.</p>
                            </div>
                        <TagsSettings />
                        </div>
                    </div>
                </div>
            </div>
        </HeaderFooterLayout >
    )
}

export default Settings
